import BaseModal from './BaseModal.vue'
import BaseDropdown from './BaseDropdown.vue'
import BaseTable from './BaseTable.vue'
import BaseEditor from './BaseEditor.vue'
import BaseDatePicker from './BaseDatePicker.vue'

export {
  BaseModal,
  BaseDropdown,
  BaseTable,
  BaseDatePicker
}

// For global registration
export default {
  install (app) {
    app.component('BaseModal', BaseModal)
    app.component('BaseDropdown', BaseDropdown)
    app.component('BaseTable', BaseTable)
    app.component('BaseEditor', BaseEditor)
    app.component('BaseDatePicker', BaseDatePicker)
  }
}
